// extracted by mini-css-extract-plugin
module.exports = {"searchContainer":"GeofencesListScreen_searchContainer__1g0j1","contentArea":"GeofencesListScreen_contentArea__3qTKx","costColumn":"GeofencesListScreen_costColumn__3t5Ir"};